import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from './assets/case-info.module.scss';
import InfoItem from 'src/components/InfoItem';
import { ICase } from 'src/types/case';
import RoleLayout from 'src/components/layout/RoleLayout';
import { RouteComponentProps } from 'react-router';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';

export interface StateProps {
    files: any;
    caseEnt: Partial<ICase> | null;
}

export interface DispatchProps {
    getFiles: (id: string | number) => void;
    getData: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const CaseInfo: React.FunctionComponent<Props> = ({
    caseEnt,
    getData,
    getFiles,
    files,
    match: {
        params: { id },
    },
}: Props) => {
    useEffect(() => {
        if (id) {
            getFiles(id);
            getData(id);
        }
        // eslint-disable-next-line
    }, [getData, getFiles]);

    if (!caseEnt) {
        return null;
    }

    const previewFiles =
        files &&
        files.map((file: any, i: number) => (
            <li style={{ listStyleType: 'none' }} key={file.attach}>
                <a rel="noopener noreferrer" target="_blank" href={`${file.attach}`}>
                    {file.name}
                </a>
            </li>
        ));
    return (
        <RoleLayout>
            <Breadcrumbs
                items={[
                    { name: 'CASES', path: routes.CASES_LIST },
                    { name: `${caseEnt.id}`, path: '' },
                ]}
            />
            <div className={classNames(styles.infoWrap)}>
                <div className={classNames(styles.infoItems)}>
                    <InfoItem title={'Case Number:'} value={caseEnt.id} />

                    <InfoItem title={'Documents:'} value={previewFiles} />
                </div>

                <div>
                    <Link
                        className={classNames('btn', 'btn-outline-secondary')}
                        to={Router.generate(routes.CASE_EDIT, { id })}
                    >
                        EDIT
                    </Link>
                </div>
            </div>
        </RoleLayout>
    );
};

export default CaseInfo;
